import { array, string } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';

const mapMimeTypeToFileExtension: Record<string, string> = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'image/jpeg': '.jpeg',
    'image/png': '.png',
    'application/json': '.json',
    'application/pdf': '.pdf',
};

const mapAcceptEntryToFileExtension = flow(string.trim, (entry: string) =>
    entry.includes('/') ? mapMimeTypeToFileExtension[entry] : entry
);

export const getFileExtensionsFromAccept = (accept: string | string[]) => {
    if (typeof accept === 'string') {
        return pipe(
            accept,
            (value) => value.split(','),
            array.map(mapAcceptEntryToFileExtension),
            (value) => value.join(', ')
        );
    }
    return pipe(accept, array.map(mapAcceptEntryToFileExtension), (value) => value.join(', '));
};
